export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["PENDING"] = "pending";
    // COMPLETED = "completed",
    PaymentStatus["FAILED"] = "failed";
    PaymentStatus["REFUNDED"] = "refunded";
    PaymentStatus["PAID"] = "paid";
})(PaymentStatus || (PaymentStatus = {}));
export var OrderStatus;
(function (OrderStatus) {
    OrderStatus["PROCESSING"] = "processing";
    OrderStatus["PLACED"] = "placed";
    OrderStatus["CONFIRMED"] = "confirmed";
    OrderStatus["PACKED"] = "packed";
    OrderStatus["SHIPPED"] = "shipped";
    OrderStatus["DELIVERED"] = "delivered";
    OrderStatus["CANCELLED"] = "cancelled";
    OrderStatus["OUT_FOR_DELIVERY"] = "out_for_delivery";
    OrderStatus["RETURNED"] = "returned";
    OrderStatus["PICK_UP_SCHEDULED"] = "pickup_scheduled";
    OrderStatus["PICKED_UP"] = "picked_up";
    OrderStatus["IN_TRANSIT"] = "in_transit";
    OrderStatus["CANCELLATION_REQUESTED"] = "cancellation_requested";
    OrderStatus["FAILED"] = "failed";
})(OrderStatus || (OrderStatus = {}));
export var RefundStatus;
(function (RefundStatus) {
    RefundStatus["PENDING"] = "pending";
    RefundStatus["PROCESSING"] = "processing";
    RefundStatus["COMPLETED"] = "completed";
    RefundStatus["FAILED"] = "failed";
})(RefundStatus || (RefundStatus = {}));
